import React from 'react';

// Styles
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export const ModalIncompleteItem = ({ open, onClose, onConfirm, items }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle textAlign="center">Cadastro de prêmio incompleto</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '16px 24px',
        }}
      >
        <DialogContentText sx={{ paddingLeft: '0px', margin: '15px 0px' }}>
          <p>Os seguintes prêmios estão com informações incompletas:</p>
          <ul style={{ margin: '2rem 0 2rem 2rem' }}>
            {items.map((index) => (
              <li key={index}>Sorteio #{index + 1}</li>
            ))}
          </ul>
          Deseja continuar mesmo assim? Os itens incompletos serão removidos.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="secondary" autoFocus>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
